import { useTranslation } from 'react-i18next'
import { Body1 } from '@dhl-ui/components'
import { TextFieldInput } from '@dhl/formik'

type Props = {
  fieldName?: string
}

export const TrackerCodeSearchField = ({ fieldName = 'trackerCode' }: Props) => {
  const { t } = useTranslation()

  return (
    <TextFieldInput
      fullWidth
      label={<Body1>{t('admin.reprintPage.trackerCodePlaceholder')}</Body1>}
      name={fieldName}
      type="search"
      slotProps={{
        htmlInput: {
          sx: {
            textTransform: 'uppercase',
          },
        },
        input: {
          endAdornment: <></>,
        },
      }}
    />
  )
}
